import { render, staticRenderFns } from "./phone-interface-data.vue?vue&type=template&id=4789ba4f&"
import script from "./phone-interface-data.vue?vue&type=script&lang=js&"
export * from "./phone-interface-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports